// ============================================================
// vendor.ts
// CDN だったライブラリをすべてここで import し window に公開する
// ============================================================

// --- CSS ---
import '../styles/vendor.scss';

// Font Awesome 7（CSSとして直接インポート）
import '@fortawesome/fontawesome-free/css/all.min.css';
// Font Awesome Animation
import 'font-awesome-animation/css/font-awesome-animation.min.css';
// flatpickr CSS
import 'flatpickr/dist/flatpickr.css';

// --- jQuery (webpack ProvidePlugin で自動注入済み。window にも明示公開) ---
import $ from 'jquery';
(window as any).$ = $;
(window as any).jQuery = $;

// --- Bootstrap ---
import * as bootstrap from 'bootstrap';
(window as any).bootstrap = bootstrap;

// --- bootbox (jQuery に依存するため bootstrap の後) ---
import bootbox from 'bootbox';
bootbox.setDefaults({ backdrop: true });
(window as any).bootbox = bootbox;

// --- Knockout ---
import * as ko from 'knockout';
import koMapping from 'knockout-mapping';

// --- knockout-mapping を明示的にインポートして ko.mapping に代入する
// webpack 環境では自動パッチが保証されないため直接アサイン
(ko as any).mapping = koMapping;

(window as any).ko = ko;

// --- Chart.js ---
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
// 標準の Colors プラグインを有効化（dataset 側で backgroundColor 未指定なら自動配色）
Chart.defaults.plugins.colors.enabled = true;
// サイト全体に合わせてチャート内のフォントも等幅 (BIZ UDGothic) で統一
Chart.defaults.font.family =
    "'BIZ UDGothic', ui-monospace, SFMono-Regular, Menlo, Consolas, 'Liberation Mono', monospace";
(window as any).Chart = Chart;

// --- chartjs-plugin-datalabels ---
import ChartDataLabels from 'chartjs-plugin-datalabels';
// グローバル登録（各ページ側での再登録は不要）
Chart.register(ChartDataLabels);
(window as any).ChartDataLabels = ChartDataLabels;

// --- linq (Enumerable) ---
import Enumerable from 'linq';
(window as any).Enumerable = Enumerable;

// --- dayjs ---
import dayjs from 'dayjs';
(window as any).dayjs = dayjs;

// --- flatpickr + 日本語ロケール ---
import flatpickr from 'flatpickr';
import { Japanese } from 'flatpickr/dist/l10n/ja';
flatpickr.localize(Japanese);
(window as any).flatpickr = flatpickr;

// --- Tom Select (Bootstrap 互換のマルチ選択UI) ---
import TomSelect from 'tom-select';
(window as any).TomSelect = TomSelect;
